export const texts = {
  label: {
    loading: 'Bitte warten',
  },
};
